import { get_token } from "@/router";
import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue"
import StickyNav from "@/components/BottomNavbar/StickyNavbar.vue";
import InactivityModal from '@/components/InactivityTracker/InactivityTracker.vue';
import Swal from 'sweetalert2';

export default {
    components: {
        HomeNavBar,
        StickyNav,
        InactivityModal
    },
    data() {
        return ({
            groups: [],
        group_search: "",
        loading: true,
        token_exists: false,
        user_id: null,
        editing: false,
        group_name: '',
        group_description: '',
        is_public: true,
        editing_group_id: null,
        errors: {},
    });
},
computed: {
    filtered_groups() {
        if (!this.group_search) {
            return this.groups;
        }
        const searchLower = this.group_search.toLowerCase();
        return this.groups.filter(group =>
            group.name.toLowerCase().includes(searchLower) ||
            (group.description && group.description.toLowerCase().includes(searchLower))
        );
    }
},
mounted() {
    this.token_exists = get_token();
    this.user_id = localStorage.getItem('user_id');
    if (this.token_exists) {
        this.fetch_groups();
    } else {
        this.$router.push({ name: 'login'}); 
    }
},
methods: {
    getToken() {
        return get_token();
    },
    fetch_groups() {
        this.loading = true;
        $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/group_management/portal_group/`,
            method: 'GET',
            headers: {
                'Authorization': `Token ${this.getToken()}`,
                'Content-Type': 'application/json'
            },
            success: (data) => {
                this.groups = data.groups.sort((a, b) => b.id - a.id);
            },
            error: (err) => {
                console.error("Error fetching groups:", err);
                // Optionally show error to user
            },
            complete: () => {
                this.loading = false;
            }
        });
    },
    handle_unauthenticated() {
        if (!this.token_exists) {
            this.$router.push({ name: 'login'}); 
            return false;
        }
        return true;
    },
    open_group(group) {
        if (!this.handle_unauthenticated()) {
            return;
        }

        const portalId = group.portal_id || 0;

        // If the user has access
        if (group.has_access === "approved" || group.is_public) {
            this.$router.push(
                `/view_group/${portalId}/${group.id}/${group.name}/${group.is_public}`
            );
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Access Denied',
                text: 'You do not have access to this group.',
                showConfirmButton: true
            });
        }
    },
    delete_group(group_id) {
        Swal.fire({
            title: "Are you sure?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
            position: 'bottom-end',
            toast: true
        }).then((result) => {
            if (result.isConfirmed) {
                $.ajax({
                    type: "DELETE",
                    url: `${process.env.VUE_APP_BACKEND_API_URL}/group_management/delete_group/`,
                    data: { group_id: group_id },
                    headers: {
                        Authorization: `Token ${this.getToken()}`,
                    },
                    success: (response) => {
                        const status = response.status;
                        if (status === "success") {
                            this.groups = this.groups.filter(
                                (group) => group.id !== group_id
                            );
                            Swal.fire({
                              title: "Deleted!",
                              text: "Group has been deleted.",
                              icon: "success",
                              position: 'bottom-end',
                              showConfirmButton: false,
                              timer: 3000,
                              toast: true
                            });
                        }
                    },
                    error: () => {
                        Swal.fire({
                            icon: "error",
                            title: "Error",
                            text: "Failed to delete the group. Please try again.",
                            position: 'bottom-end',
                            showConfirmButton: false,
                            timer: 3000,
                            toast: true
                        });
                    },
                });
            }
        });
    },
    open_edit_group_modal(group) {
        this.editing = true;
        this.group_name = group.name;
        this.group_description = group.description || '';
        this.is_public = group.is_public;
        this.editing_group_id = group.id;
        $("#create_group_modal").modal("show");
    },
    open_create_group_modal() {
        this.editing = false;
        this.group_name = '';
        this.group_description = '';
        this.is_public = true;
        this.editing_group_id = null;
    },
    handle_submit() {
        if (!this.editing) {
            this.create_group();
            return;
        }
        this.update_group();
    },
    create_group() {
        if (!this.handle_unauthenticated() || !this.validation_group_form()) {
            return;
        }
        const payload = {
            name: this.group_name,
            is_public: this.is_public,
        };
        if (this.group_description.trim()) {
            payload.description = this.group_description;
        }

        $.ajax({
            type: "POST",
            url: `${process.env.VUE_APP_BACKEND_API_URL}/group_management/create_group/`,
            contentType: "application/json",
            headers: {
                'Authorization': `Token ${this.getToken()}`,
                'Content-Type': 'application/json'
            },
            data: JSON.stringify(payload),
            success: (response) => {
                const status = response.status;
                if (status === "success") {
                    Swal.fire({
                        icon: "success",
                        title: "Success",
                        text: "Group Created Successfully",
                        showConfirmButton: false,
                        timer: 2000,
                        position: 'bottom-end',
                        toast: true
                    }).then(() => {
                        this.fetch_groups();
                        $("#create_group_modal").modal("hide");
                    });
                }
            },
            error: (response) => {
                const response_data = response.responseJSON;
                if (response_data.status === "error") {
                    this.errors.group_name = response_data.message;
                }
            },
        });
    },
        update_group() {
            if (!this.handle_unauthenticated() || !this.validation_group_form()) {
                return;
            }
            const payload = {
                name: this.group_name,
                group_id: this.editing_group_id,
                description: this.group_description,
                is_public: this.is_public,
            };

            $.ajax({
                type: "POST",
                url: `${process.env.VUE_APP_BACKEND_API_URL}/group_management/update_group/`,
                contentType: "application/json",
                headers: {
                    Authorization: `Token ${this.getToken()}`,
                    "Content-Type": "application/json",
                },
                data: JSON.stringify(payload),
                success: (response) => {
                    const status = response.status;
                    if (status === "success") {
                        Swal.fire({
                            icon: 'success',
                            title: 'Success',
                            text: 'Group Updated Successfully',
                            showConfirmButton: false,
                            timer: 2000,
                            position: 'bottom-end',
                            toast: true
                        }).then(() => {
                            this.fetch_groups();
                            $("#create_group_modal").modal("hide");
                            this.editing = false;
                        });
                    }
                },
                error: (response) => {
                    const response_data = response.responseJSON;
                    if (response_data && response_data.status === "error") {
                        this.errors.group_name = response_data.message;
                    }
                },
            });
        },
        validation_group_form() {
            this.errors = {};
            let valid = true;

            if (!this.group_name) {
                this.errors.group_name = "Group name is required";
                valid = false;
            }
            if (this.is_public == null) {
                this.errors.group_name = "Visibility is required";
                valid = false;
            }return valid;
        },
    }
};
